import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeaderTemplate from "../templates/HeaderTemplate";
// import Stack from "@mui/material/Stack";
// import Button from "@mui/material/Button";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/missions");
  }, [navigate]);

  return (
    <>
      <div>
        <HeaderTemplate />
      </div>

      {/* <Stack spacing={2} direction="row">
        <Button variant="text" sx={{ textTransform: "none" }}>
          <Link to="/mission">ミッション</Link>
        </Button>
      </Stack> */}
    </>
  );
};

export default Home;
